import React from 'react';
import { Link } from 'react-router-dom';
import './BlogsPage.css'; 
import deepseekCardBanner from '../assets/images/deepseek_card_banner.jpg'; 

const blogPosts = [
  {
    slug: 'how-deepseek-works',
    title: 'How DeepSeek Works: An Accessible Overview',
    summary: 'An overview of the DeepSeek model, its architecture, efficiency, and why it matters in the world of AI.',
    image: deepseekCardBanner 
  },
  // Add more blog posts here as needed
];

const BlogsPage = () => {
  return (
    <div className="blogs-page-container">
      <h1 className="blogs-page-title">Our Blog</h1>
      <div className="blog-cards-grid">
        {blogPosts.map((post) => (
          <div key={post.slug} className="blog-card">
            {post.image && (
              <img src={post.image} alt={post.title} className="blog-card-image" />
            )}
            <h2 className="blog-card-title">{post.title}</h2>
            <p className="blog-card-summary">{post.summary}</p>
            <Link to={`/blogs/${post.slug}`} className="blog-card-read-more">Read more</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogsPage;
